<script lang="ts">
	import Button from "../atoms/Button.svelte"

	export let klass = ''
	export let full = false
	export let rounded = false
	export let loading = false
	export let disabled = false
	export let click

	$: color = disabled ? "bg-gray-200" : "bg-blue-400 hover:bg-blue-500"
</script>

<Button
	klass={klass}
	color={color}
	full={full}
	rounded={rounded}
	loading={loading}
	click={click}
	disabled={disabled}
><slot></slot>
</Button>